export const LoginType = {
    LOGIN: "LOGIN",
    FORCE_CHANGE_PASSWORD: "FORCE_CHANGE_PASSWORD",
    FORGOT_PASSWORD: "FORGOT_PASSWORD"
}